
import React, { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';
import { Menu, X } from 'lucide-react';
import { Logo } from './nav/Logo';
import { DesktopMenu } from './nav/DesktopMenu';
import { MobileMenu } from './nav/MobileMenu';

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const isMobile = useIsMobile();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigation = (anchor?: string) => {
    if (anchor) {
      // If we have an anchor, wait for navigation to complete then scroll
      setTimeout(() => {
        const element = document.querySelector(anchor);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Regular navigation - scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    closeMobileMenu();
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className={cn(
      "fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-4 px-4 md:px-8",
      scrolled ? "bg-white/80 backdrop-blur-md shadow-sm" : "bg-transparent"
    )}>
      <div className="container mx-auto flex items-center justify-between">
        <Logo />
        
        <DesktopMenu handleNavigation={handleNavigation} />
        
        {isMobile && (
          <button 
            onClick={toggleMobileMenu}
            className="text-brand-darkgrey p-2 focus:outline-none"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        )}
        
        {!isMobile && (
          <a 
            href="https://cutshort.io/a/generic-emp-form" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-brand-blue text-white px-6 py-2 rounded-lg shadow-md transition-all hover:shadow-lg hover:translate-y-[-1px]"
          >
            Get a callback
          </a>
        )}
      </div>
      
      {isMobile && (
        <MobileMenu
          mobileMenuOpen={mobileMenuOpen}
          handleNavigation={handleNavigation}
          closeMobileMenu={closeMobileMenu}
        />
      )}
    </header>
  );
};

export default NavBar;
